import { showError as _showError } from "@/utils";
import { isDev } from "./index";

export function showError(message) {
  // return isDev ? _showError(message) : toastInApp(message)
  return _showError(message);
}

function toastInApp(message) {
  lightAppJssdk.notification.toast({
    text: message, //提示信息
    success: function (data) {
      //成功回调
    },
    fail: function (data) {
      //错误返回
    },
  });
}
